/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const EnvelopeSimple = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 4.125H3C2.70163 4.125 2.41548 4.24353 2.2045 4.4545C1.99353 4.66548 1.875 4.95163 1.875 5.25V18C1.875 18.4973 2.07254 18.9742 2.42417 19.3258C2.77581 19.6775 3.25272 19.875 3.75 19.875H20.25C20.7473 19.875 21.2242 19.6775 21.5758 19.3258C21.9275 18.9742 22.125 18.4973 22.125 18V5.25C22.125 4.95163 22.0065 4.66548 21.7955 4.4545C21.5845 4.24353 21.2984 4.125 21 4.125ZM18.1078 6.375L12 11.9738L5.89219 6.375H18.1078ZM4.125 17.625V7.8075L11.2397 14.3297C11.4472 14.52 11.7185 14.6255 12 14.6255C12.2815 14.6255 12.5528 14.52 12.7603 14.3297L19.875 7.8075V17.625H4.125Z"
          fill="#002967"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4753_25352)">
        <path
          d="M15.1111 1.77783H0.888889C0.653141 1.77783 0.427049 1.87148 0.26035 2.03818C0.0936506 2.20488 0 2.43097 0 2.66672V12.7408C0 13.1337 0.156084 13.5105 0.433916 13.7884C0.711748 14.0662 1.08857 14.2223 1.48148 14.2223H14.5185C14.9114 14.2223 15.2883 14.0662 15.5661 13.7884C15.8439 13.5105 16 13.1337 16 12.7408V2.66672C16 2.43097 15.9063 2.20488 15.7396 2.03818C15.573 1.87148 15.3469 1.77783 15.1111 1.77783ZM12.8259 3.55561L8 7.97931L3.17407 3.55561H12.8259ZM1.77778 12.4445V4.68746L7.39926 9.8408C7.56321 9.99113 7.77756 10.0745 8 10.0745C8.22244 10.0745 8.43679 9.99113 8.60074 9.8408L14.2222 4.68746V12.4445H1.77778Z"
          fill="#002967"
        />
      </g>
      <defs>
        <clipPath id="clip0_4753_25352">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EnvelopeSimple;
